export const DMS_MODULE = 'Uctenky';
export const NAME = 'Uctenky';
